import {useState} from 'react'
import './Banner.css'
import Toggle from '../../../../../components/Toggle/Toggle'
import { useContext} from 'react'
import { DashboardContext } from '../../../../../Hooks/DashboardContext'
import { UpdateDoc } from '../../../../../firebase/utils'


const Banner = ({bannerDetails}) => {
 const {CurrentBannerNumber,setCurrentBannerNumber,MaxBannerNumber}=useContext(DashboardContext)
 const [isChecked,setIschecked]=useState(bannerDetails.isChecked)


  const HandleBannerToggle=()=>{

    if (isChecked) {

      UpdateDoc("Banners",bannerDetails.id,{...bannerDetails,isChecked:false})
      setIschecked(false)
   
    }
    else {
      
     UpdateDoc("Banners",bannerDetails.id,{...bannerDetails,isChecked:true})
     setIschecked(true)

    }

  }


  return (
    <div id='Banner_Card'>

      <div className='Banner_Img'>
        <img src={bannerDetails.imgUrl} alt="" />
      </div>

      <div className='Banner_Text'> 
        <div>
          <div className='Banner_Text_Nom'>{bannerDetails.Nom}</div>
          <div className='Banner_Text_Cat'>{bannerDetails.Categorie}</div>
        </div>
        
      <Toggle isChecked={isChecked} HandleToggle={HandleBannerToggle}/>
      </div>

      

      

    </div>
  )
}

export default Banner